import {HTML_MODAL, IShowHtmlEditorModalAction} from './types/html.types';

export const showHtmlEditorModalAction = (): IShowHtmlEditorModalAction => ({
    type: HTML_MODAL,
});
